interface BankNumberOption {
  key: string;
  text: string;
}

export const bankNumberOptions: Array<BankNumberOption> = [
  {
    key: "756",
    text: "756 - Banco Sicoob"
  },
  {
    key: "748",
    text: "748 - Banco Sicredi"
  }
];
